<template>
  <Flag width="21px" height="21px" class="rounded margin-right-xxs" />

  <span>{{ currencyCode }}</span>

  <button aria-label="Change currency and country" :tabindex="props.tabindex" @click.prevent="openInternationalContextSlideout">
    <span class="link-sm small">Change</span>
  </button>
</template>

<script setup>
import { computed } from 'vue';
import Flag from '../common/Flag.common';
import useInternationalSlideout from '~/composables/features/useInternationalSlideout';
import { RESET_OVERLAY } from '#shared/types/actions';
import useScrollLock from '~/composables/ui/useScrollLock';
import { useMobileNav } from '~/composables/useMobileNav';

const props = defineProps({
  tabindex: {
    type: [String, Number],
    default: () => null,
  },
});

const navOverlay = useNavOverlay();
const pageData = usePageData();

const { unlock } = useScrollLock();
const { isMenuOpened, wasSideNavVisibleRecently } = useMobileNav();
const { openInternationalSlideout } = useInternationalSlideout();
const currencyCode = computed(() => pageData.navigation.context.currencyCode);

function openInternationalContextSlideout() {
  isMenuOpened.value = false;
  wasSideNavVisibleRecently.value = false;
  navOverlay?.[RESET_OVERLAY]();
  openInternationalSlideout();
  unlock();
}
</script>

<style lang="scss" brand="bcom" scoped>
button {
  margin-left: 4px;
}

:deep(.flag.rounded) {
  width: 21px;
  height: 21px;
}
</style>
